import DirectorEasy from '../director/DirectorEasy'
import DirectorGeneral from '../director/DirectorGeneral'
import DirectorHard from '../director/DirectorHard'

export default {
  DirectorEasy,
  DirectorGeneral,
  DirectorHard
}
